import {_, React, observer, observable, computed, action, useLocalStore} from '@api'
import {FieldRendererStore, CatalogItemSidebarDetailsStore, useFieldRendererStore} from '@design-board/stores'
import {} from '@stores'
import {} from '@modules'
import * as css from './AnnotateImages.css'
import Annotation from 'react-image-annotation'

/// region Store

export class AnnotateImagesStore {
  constructor(public field: FieldRendererStore) {
  }

  // @computed get type() {
  //
  // }

  @observable annotation = {}

  @observable annotations = []

  @action onChange = (annotation) => {
    this.annotation = annotation
  }


  @action onSubmit = (annotation) => {
    const {geometry, data} = annotation

    this.annotation = {}
    this.annotations = [
      ...this.annotations, {
        geometry,
        data: {
          ...data,
          id: Math.random()
        }
      }
    ]
  }

  @observable private selectedImageIndex = 0


  @computed get selectedImage() {
    const {field: {detailsStore: {localImages}}, selectedImageIndex} = this
    return _.isEmpty(localImages) ? null : localImages[selectedImageIndex]?.largeImageURL
  }
}

export const AnnotateImagesStoreContext = React.createContext<AnnotateImagesStore>(null)
export const useAnnotateImagesStore = () => React.useContext(AnnotateImagesStoreContext)

/// endregion

/// region Components

export const AnnotateImages = observer(function AnnotateImages() {
  const fieldRendererStore = useFieldRendererStore(),
    store = useLocalStore(() => new AnnotateImagesStore(fieldRendererStore)),
    {annotation, annotations, onChange, onSubmit, selectedImage} = store

  return (
    <AnnotateImagesStoreContext.Provider value={store}>
      <div className={css.root}>
        {_.isEmpty(selectedImage) ? <div>No Images</div> :
        <Annotation
          src={selectedImage}
          alt='Two pebbles anthropomorphized holding hands'

          annotations={annotations}
          // type={type}
          value={annotation}
          onChange={onChange}
          onSubmit={onSubmit}
        />}
      </div>
    </AnnotateImagesStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/AnnotateImages.tsx